import { Button, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';


function TableActionArchive(props) {

    const { onClick } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    return (
        <Button
            onClick={onClick}
            sx={{
                backgroundColor: colors.primary[400],
                '&:hover': {
                    backgroundColor: colors.primary[400],
                    color: colors.blueAccent[500]
                }
            }}
        >
            <Inventory2OutlinedIcon />
        </Button>
    );
};

export default TableActionArchive;